// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"189":"fd327118","507":"cd9c21ff","540":"02efa03b","553":"32af3545","623":"16b9dbf9","668":"6540ca2e","767":"6ce79ff0","803":"d25deb0a","813":"8702be72","826":"2b1e472d","917":"836fb8dc","984":"be41036a","988":"4d3786ce"}[chunkId] + ".chunk.js";
};